import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import {
  Button, 
  Card, 
  CardBody, 
  CardGroup, 
  Col, 
  Container, 
  Input, 
  InputGroup, 
  InputGroupText, 
  Row,
} from 'reactstrap';

import Loading from '../../Component/Loading';
import ErrorMessage from '../../Component/ErrorMessage';
import { mfaVerify, mfaClear, mfaRequired  } from '../../../redux/actions/authActions';

import { useTranslation, withTranslation } from 'react-i18next';

const MfaScreen = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const { auth, mfa, error, loading } = useSelector((store) => store.auth);

  const [code, setCode] = useState('');

  // Si no hay MFA pendiente, volver a login
  /* useEffect(() => {
    if (!mfa?.required) {
      history.push('/login');
    }
  }, [mfa?.required]); */

  // Si ya autentico (porque MFA OK), seguir el mismo flujo que Login.jsx:
  /* useEffect(() => {
    if (auth?.authenticated) {
      if (auth?.canLogin) history.push('/impersonate');
      else history.push('/');
    }
  }, [auth?.authenticated]); */

  useEffect(() => {
    if (mfa?.required) return;

    const raw = sessionStorage.getItem('pimsMfa');
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        const mfaToken = parsed?.mfaToken || parsed?.token || parsed?.ticket;
        if (mfaToken) {
          dispatch(mfaRequired({
            mfaToken,
            mfaType: parsed?.mfaType || parsed?.type || 'TOTP',
            emailMasked: parsed?.emailMasked || null,
            canLogin: !!parsed?.canLogin,
          }));
          return;
        }
      } catch (_) {
        // ignore parse error
      }
    }

    // si no hay MFA pendiente ni storage válido -> login
    history.push('/login');
  }, [mfa?.required]);

    // Si ya autenticó (MFA OK), seguir flujo normal
  useEffect(() => {
    if (auth?.authenticated) {
      if (auth?.canLogin) history.push('/impersonate');
      else history.push('/');
    }
  }, [auth?.authenticated]);

  // expirado / inválido
  useEffect(() => {
    if (error?.code === 'MFA_EXPIRED' || error?.status === 410) {
      dispatch(mfaClear());
      sessionStorage.removeItem('pimsMfa');
      history.push('/login');
    }
  }, [error]);

  const onSubmit = () => {
    // Normaliza a 6 dígitos (TOTP) — para EMAIL también suele ser numérico
    const normalized = (code || '').replace(/\s/g, '');
    dispatch(mfaVerify({ code: normalized }));
  };

  const onKeyPress = (e) => {
    if (e.charCode === 13) onSubmit();
  };

  const title =
    mfa?.type === 'EMAIL'
      ? t('Mfa.page.typeEmail')
      : t('Mfa.page.typeTOTP');

  const hint =
    mfa?.type === 'EMAIL'
      ? `${t('Mfa.page.emailMsg')} ${mfa?.emailMasked || t('Mfa.page.yourEmail')}.`
      : t('Mfa.page.TOTPMsg');

  return (
    <div>
      {loading ? (<Loading loading />) : (
        <div className="app flex-row align-items-center">
          <Container>
            <Row className="justify-content-center">
              <Col md="6">
                <CardGroup>
                  <Card className="p-4">
                    <CardBody>
                      <h3 style={{ marginBottom: 10, textAlign: 'center' }}>{title}</h3>
                      <p style={{ textAlign: 'center', opacity: 0.8 }}>{hint}</p>

                      <InputGroup className="mb-3">
                        <div className="input-group-prepend">
                          <InputGroupText>
                            <i className="icon-key" />
                          </InputGroupText>
                        </div>

                        <Input
                          type="text"
                          placeholder={t("Mfa.page.codePlaceholder")}
                          value={code}
                          onChange={(e) => setCode(e.target.value)}
                          onKeyDown={onKeyPress}
                          maxLength="10"
                        />
                      </InputGroup>

                      {error?.message ? (
                        <ErrorMessage style={{ marginLeft: 15 }} message={error.message} danger />
                      ) : null}

                      <Row>
                        <Button color="success" className="px-4 w-100" onClick={onSubmit} style={{ marginLeft: 15 }}>
                          {t('Mfa.page.validate')}
                        </Button>
                      </Row>

                      {/* FUTURO: MFA EMAIL -> boton reenviar (cuando implementes backend)
                      {mfa?.type === 'EMAIL' && (
                        <Row className="mt-2">
                          <Button color="link" onClick={...}>Reenviar código</Button>
                        </Row>
                      )}
                      */}
                    </CardBody>
                  </Card>
                </CardGroup>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </div>
  );
};

export default (withTranslation()(MfaScreen)) ;
